export function ReceiveControlBoxConstructor(services, type) {

  const joint = services.joint;
  let label;
  switch (type) {
    case 'html.ReceiveControlBox':
      label = services.$translate.instant('parameters/quick_replies/details/graph/receive_control_box_title_in_diagram');
      break;
    case 'html.MessengerMDotMeLinkBox':
      label = services.$translate.instant('parameters/quick_replies/details/graph/m_dot_me_box_title_in_diagram');
      break;
    case 'html.ExternalEndpointEntryPointBox':
      label = services.$translate.instant('parameters/quick_replies/details/graph/external_endpoint_box_title_in_diagram');
      break;
    case 'html.LinkWithRefEntryPointBox':
      label = services.$translate.instant('parameters/quick_replies/details/graph/link_with_ref_entry_box_title_in_diagram');
      break;
   }

  const defaults = joint.util.deepSupplement({
    'labelText': label,
    'type': type,
  }, joint.shapes.html.GetStartedBox.prototype.defaults);

  return joint.shapes.html.GetStartedBox.extend({
    defaults: defaults
  });

}
